import React, { useState } from 'react'
import { Body, Box, H3 } from './layout'
import { faq } from '../faq'

export const FAQ = () => (
  <Box
    column
    gap={50}
    p="80px 24px 180px 24px"
    maxWidth={877}
  >
    <H3 align="left">
      Frequently asked questions
    </H3>

    <Box column>
      {faq.map((section, i) =>
        <Sections key={i} {...section} />
      )}
    </Box>
  </Box>
)

const Sections = ({ name, questions }) => {
  const [open, setOpen] = useState(false)

  return (
    <Box
      column
      p="32px 0 16px 0"
      gap={16}
      style={{ borderBottom: !open && '1px solid rgba(255, 255, 255, 0.2)'}}
      onClick={() => setOpen(open => !open)}
      cursor="pointer"
      overflow="hidden"
      className="underline-links"
    >
      <Box fullWidth justifyContent="space-between" alignItems="center" gap={16}>
        <Body size={32} bold>
          {name}
        </Body>
        <div>
          <Box rotate={open ? -225 : 0} transition={0.25} transformOrigin="center center">
            <Body size={42}>+</Body>
          </Box>
        </div>
      </Box>
      <Box column maxHeight={open ? 'unset' : 0} transition={0.25} opacity={open ? 1 : 0}>
        {questions.map(({ q, a }, i) =>
          <Question key={i} q={q} a={a} />
        )}
      </Box>
    </Box>

  )
}

const Question = ({ q, a }) => {
  const [open, setOpen] = useState(false)

  return (
    <Box
      column
      p="32px 0 16px 0"
      gap={16}
      style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.2)'}}
      onClick={(e) => {
        e.stopPropagation()
        setOpen(open => !open)
      }}
      cursor="pointer"
      overflow="hidden"
      className="underline-links"
    >
      <Box fullWidth justifyContent="space-between" alignItems="center" gap={16}>
        <Body size={18} bold>
          {q}
        </Body>
        <div>
          <Box rotate={open ? -225 : 0} transition={0.25} transformOrigin="center center">
            <Body size={32}>+</Body>
          </Box>
        </div>
      </Box>

      <Box maxHeight={open ? 400 : 0} transition={0.25} opacity={open ? 1 : 0}>
        <Body small lineHeight={1}>{a}</Body>
      </Box>
    </Box>
  )
}